/**
 * 该文件存放首页相关页面路由
 */

const homeRoutes = [
  {
    path: '/',
    component: () => import('@/homepage'),
    children: [
      // 首页--供应商端
      {
        path: '/index',
        name: 'Index',
        meta: {
          menuName: 'homepage'
        },
        component: () => import('@/pages/index/index')
      },
      // 首页--药店端
      {
        path: '/index-store',
        name: 'IndexStore',
        meta: {
          menuName: 'homepage'
        },
        component: () => import('@/pages/index/index')
      },
      // 公告列表页
      {
        path: '/broadcast-list',
        name: 'BroadcastList',
        meta: {
          menuName: 'home'
        },
        component: () => import('@/pages/broadcast-list')
      },
      // 帮助中心页
      {
        path: '/help-center',
        name: 'HelpCenter',
        meta: {
          menuName: 'help-center'
        },
        component: () => import('@/pages/help-center')
      },
      // 通知中心
      {
        path: '/notification-center',
        name: 'NotificationCenter',
        meta: {
          menuName: 'home'
        },
        component: () => import('@/pages/notification-center')
      },
    ]
  }
];

export default homeRoutes;
